// src/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  const handleLogout = () => {
    // Clear session or localStorage (for demo, we'll just redirect)
    window.location.href = '/login';
  };

  return (
    <div className="home-container">
      <h2>Welcome to DevAuto Up!</h2>
      <div className="menu">
        <Link to="/action-runs" className="menu-item">Action Runs</Link>
        <Link to="/billing" className="menu-item">Billing</Link>
        <Link to="/company-address" className="menu-item">Company Address</Link>
      </div>
      <div className="actions">
        <Link to="/profile" className="btn">Profile</Link>
        <button className="btn" onClick={handleLogout}>Logout</button>
      </div>
    </div>
  );
}

export default Home;
